import React from 'react';
import {FaPen} from "react-icons/fa";

const EquipmentButtons = (params) => {
    const {api, node, modalRender, title} = params;

    return (
        <div className="flex flex-row justify-center h-full w-full">
            <span onClick={() => modalRender(params, title, api, node)} className="w-[60px] h-full flex justify-center items-center text-gray-900 bg-gray-50 shadow border border-gray-300 cursor-pointer rounded-md me-[6px]">
                <FaPen/>
            </span>
        </div>
    );
};

export default EquipmentButtons;